import React, { useState, useMemo } from 'react';

// Material UI
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import { Typography, DialogActions } from '@mui/material';

// Components
import Dropdown from '../../../../components/inputs/dropdown';
import Modal from '../../../../components/modal/index';

// Models
import { countriesEnum, DocumentType, GetInvoiceTypeByCountry, TaxConditionType } from '../../../../models/EnumEntity';
import useCart from '../../../../hooks/orders/CartProvider';

const InvoiceData = ({ onClose, open }) => {
    const { sale: { country, invoiceType, customer  }, update } = useCart();
    const [invoiceSelected, setInvoiceSelected] = useState(invoiceType);

    const taxConditionValid = useMemo(() => {
        if (country === countriesEnum.AR) {
            if (customer?.taxCondition === TaxConditionType.FinalConsumer)
                return customer?.taxCondition !== TaxConditionType.FinalConsumer &&
                    customer?.taxCondition !== TaxConditionType.ExteriorClient;

            if (customer?.taxCondition === TaxConditionType.SingleTaxSystemPayer)
                return false;

            return customer?.taxCondition !== TaxConditionType.Exempt &&
                customer?.taxCondition !== TaxConditionType.ExteriorClient;
        }
        if (country === countriesEnum.UY)
            return customer?.documentType !== DocumentType.CI;

        return false;
    }, [country, customer])

    const handleSave = () => {
        if (invoiceSelected !== invoiceType) {
            update({ invoiceType: invoiceSelected });
        }

        onClose();
    }

    return (
        <Modal
            open={open}
            onClose={onClose}
            title='Tipo de facturación'
            contentProps={{ dividers: true }}
            customButtons={() =>
                <DialogActions>
                    <Button
                        onClick={onClose}
                        color="primary"
                    >
                        Cancelar
                    </Button>
                    <Button
                        onClick={handleSave}
                        color="primary"
                        variant='contained'
                        disabled={!taxConditionValid}
                    >
                        Guardar
                    </Button>
                </DialogActions>
            }
        >
            <Grid container spacing={2}>
                {
                    !taxConditionValid &&
                    <Grid size={12}>
                        <Typography>
                            {country === countriesEnum.AR
                                ? customer?.taxCondition === TaxConditionType.SingleTaxSystemPayer
                                    ? "El cliente Monotributista solo puede realizar Factura A"
                                    : "El cliente debe ser Responsable Inscripto para poder realizar Factura A"
                                : "El cliente debe tener RUT para hacer E-Factura"
                            }
                        </Typography>
                    </Grid>
                }
                <Grid size={12}>
                    <Dropdown
                        fullWidth
                        name='invoiceType'
                        label='Tipo de factura'
                        onChange={(event) => setInvoiceSelected(event.target.value)}
                        value={invoiceSelected}
                        values={GetInvoiceTypeByCountry(country)}
                        disabled={!taxConditionValid}
                    />
                </Grid>
            </Grid>
        </Modal>
    );
}
export default InvoiceData;